// Custom Chakra v3 conditions for A6. `compact` is the density condition —
// deliberately wrapped in @media (pointer: fine) so compact density can never
// shrink a touch target (spec §3.8 invariant). Absence of [data-density=compact]
// on any ancestor = comfortable, which is the default. `touch` is the coarse-
// pointer branch: on a phone/tablet it raises height-bearing controls to ≥44px.
export const conditions = {
  compact: '@media (pointer: fine) { [data-density=compact] & }',
  touch: '@media (pointer: coarse)',
} as const
